import { defineNuxtPlugin } from '#app/nuxt'
import { LazyPicker, LazyProductCard } from '#components'
const lazyGlobalComponents = [
  ["Picker", LazyPicker],
["ProductCard", LazyProductCard],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
